import { homeApi } from '@features/home/api/homeApi'
import { EMPTY_DAILY_STATISTICS } from '@features/home/constants'
import { formatDailyStatistic } from '@features/home/services/formatDailyStatistic'

/**
 * Загружает и форматирует ежедневную статистику главной страницы.
 *
 * @returns состояние ошибки и отформатированный список статистики
 */
export const useDailyStatistics = async () => {
  const { data, error } = await homeApi.getDailyStatistics()

  const isFetchError = computed(() => Boolean(error.value))

  const dailyStatisticsList = computed(() => {
    const source = data.value?.length ? data.value : EMPTY_DAILY_STATISTICS

    return source.flatMap((statistic, index) => {
      const formatted = formatDailyStatistic(statistic, index)
      return formatted ? [formatted] : []
    })
  })

  return {
    isFetchError,
    dailyStatisticsList,
  }
}
